import ArrowDownIcon from '@atlaskit/icon/core/arrow-down';
import React from 'react';

export const SvgArrowDownward = () => (
  <ArrowDownIcon label="" testId="ads-refreshed-icon" />
);
